export class DependencyLicenseListLoad {
  public static readonly type = '[DependencyLicenseList] Load';
}

export class DependencyLicenseListInitialState {
  public static readonly type = '[DependencyLicenseList] Set initial state';
}
